export default {
	title: "Web3",
	rule: "Pravidlá vysvětlení",
	safe: "Bezpečnost peněžních prostředků",
	balance: {
		totle: "Celková suma",
		yesterday: "Včerejší výnos",
		cumulatively: "Kumulatívní výnos",
		in: "Vklad",
		out: "Výber",
		available: "Dostupný zůstatek"
	},
	actions: {
		in: "Vklad",
		out: "Výber"
	},
	type: ["Všechny", "Vklad", "Výber", "Výnos"],
	TransactionPassword: "Transakční heslo",
	Amount: "Suma",
	date: "Datum"
};
